import moment from "moment";
import "moment/locale/sv";
import "moment/locale/fi";

const formatDate = (date, locale) => {

  if(!locale) return date;

  moment.locale(locale)
  const momentDate = moment(Date.parse(date));

  if (momentDate.isValid()) {
    return momentDate.format("LL");
  }

  return date;
};

export default formatDate;
